export default class Basket {
  constructor() {
    this.basket_token = null;
    this.conference = {
      date: null,
      event_logo_url: null,
      id: null,
      is_agenda_group: false,
      landing_page_bg_url: null,
      name: null,
      organization_id: null,
      registration_disabled: false
    };
    this.options = {
      currency: "usd",
      currency_symbol: "$"
    };
    this.order = {
      history: [],
      summary: {
        addons_price: 0,
        app_fee: 0,
        coupon_discount: 0,
        donation: null,
        group_discount: 0,
        price: 0,
        stripe_fee: 0,
        total_price: 0,
      },
      tickets: []
    };
    this.settings = {
      checkoutNote: '',
      checkoutSuccessNote: '',
      customSuccessEnabled: false,
      customSuccessUrl: '',
      donation_enabled: false,
      donation_title: '',
      emailReceiver: '',
      freePaymentMessage: '',
      has_coupons: false,
      instalmentPayments: false,
      successPaymentMessage: '',
      google_analytics_id: null,
      google_tag_manager_id: null,
      google_ads_id: null,
      google_ads_conversation_id: null,
      wild_apricot_enabled: false
    };
    this.tickets = {
      inperson: [],
      virtual: [],
    };
  }
}
